// src/components/PageViewTracker.tsx
'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useCallback } from 'react';

export default function PageViewTracker() {
  const pathname = usePathname();

  const track = useCallback(() => {
    if (typeof window === 'undefined') return;
    if (localStorage.getItem('analytics_consent') !== 'granted') return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'page_view', page: pathname });

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { page_path: pathname });
    }
  }, [pathname]);

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(track);
    } else {
      setTimeout(track, 200);
    }
  }, [track]);

  return null;
}
